<template>
  <div>
    <v-card class="overflow-hidden">
      <v-card-text>
        <v-row>
          <v-col>
            <customer-autocomplete-filter
              :fatherEditedCustomer="filterInstallationNotice"
              :editedCustomerIndex="-1"
              :customerName="'quotation_customer_number'"
              @setFilterCustomer="setFilterCustomer"
            />
          </v-col>
          <v-col>
            <v-text-field
              :label="$t('installation_notice_number')"
              v-model="filterInstallationNotice.NoticeNumber"
              @input="getInstallationNotice"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              :label="$t('quotation_license_plate')"
              v-model="filterInstallationNotice.LicensePlate"
              @input="getInstallationNotice"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-autocomplete
              :items="maintenanceEngineers"
              :label="$t('installation_notice_engineer')"
              v-model="filterInstallationNotice.MaintenanceEngineer"
              item-text="NickName"
              item-value="UserName"
              :loading-text="$t('common_get_data')"
              :no-data-text="$t('common_no_results')"
              @change="getInstallationNotice"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              :label="$t('installation_notice_contact_name') + ' (1)'"
              v-model="filterInstallationNotice.FirstContactName"
              @input="getInstallationNotice"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              :label="$t('installation_notice_contact_phone') + ' (1)'"
              v-model="filterInstallationNotice.FirstContactPhone"
              @input="getInstallationNotice"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              :label="$t('installation_notice_contact_name') + ' (2)'"
              v-model="filterInstallationNotice.SecondContactName"
              @input="getInstallationNotice"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              :label="$t('installation_notice_contact_phone') + ' (2)'"
              v-model="filterInstallationNotice.SecondContactPhone"
              @input="getInstallationNotice"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-autocomplete
              :items="zoneList"
              item-text="Name"
              item-value="Type"
              :loading-text="$t('common_get_data')"
              :no-data-text="$t('common_no_results')"
              :label="$t('fix_zone')"
              v-model="filterInstallationNotice.ZoneType"
              @change="getInstallationNotice"
            >
            </v-autocomplete>
          </v-col>
          <v-col>
            <v-autocomplete
              :items="allSpecialNeedList"
              item-text="Name"
              item-value="Id"
              :label="$t('quotation_special_need')"
              v-model="filterInstallationNotice.SpecialNeedId"
              :loading-text="$t('common_get_data')"
              :no-data-text="$t('common_no_results')"
              @change="getInstallationNotice"
            ></v-autocomplete>
          </v-col>
          <v-col>
            <v-text-field
              :label="$t('quotation_car_place')"
              v-model="filterInstallationNotice.CarPlace"
              @input="getInstallationNotice"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-checkbox
              v-model="filterInstallationNotice.IsRange"
              :label="$t('installation_notice_is_range')"
              @click="setIsChange"
            ></v-checkbox>
          </v-col>
          <v-col v-if="!filterInstallationNotice.IsRange">
            <v-text-field
              :label="$t('quotation_number')"
              v-model="filterInstallationNotice.QuotationNumber"
              @input="getInstallationNotice"
            ></v-text-field>
          </v-col>
          <v-col v-if="filterInstallationNotice.IsRange">
            <v-text-field
              :label="$t('installation_notice_start_quotation_number')"
              v-model="filterInstallationNotice.StartQuotationNumber"
              @input="getInstallationNotice"
            ></v-text-field>
          </v-col>
          <v-col v-if="filterInstallationNotice.IsRange">
            <v-text-field
              :label="$t('installation_notice_end_quotation_number')"
              v-model="filterInstallationNotice.EndQuotationNumber"
              @input="getInstallationNotice"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-data-table
      :headers="installationNoticeDataTableHeaders"
      :items="installationNoticeList"
      class="elevation-1 my-5"
      :loading="isInstallationNoticeLoading"
      :loading-text="$t('common_get_data')"
      :no-data-text="$t('common_no_data')"
      :no-results-text="$t('common_no_results')"
      :footer-props="{
        'items-per-page-options': [30, 50, 100],
        'items-per-page-text': $t('item_rows_per_page'),
      }"
      :server-items-length="totalRows"
      :options="currentOptions"
      @update:options="updateOptions"
      :header-props="headerProps"
    >
      <template v-slot:[`item.LicensePlate`]="props">
        <v-edit-dialog v-if="!props.item.IsWork && props.item.NoticeType === 1">
          {{ props.item.LicensePlate }}
          <template v-slot:input>
            <v-text-field
              v-model="props.item.LicensePlate"
              label="Edit"
              single-line
              @blur="changeLicensePlate(props.item)"
            ></v-text-field>
          </template>
        </v-edit-dialog>
        <span v-else>{{ props.item.LicensePlate }}</span>
      </template>
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>{{ $t('installation_notice_toolbar_title') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark class="mb-2 ml-8" @click="isShowUpdateDataStepDialogBtn">
            批次修改資料
          </v-btn>
          <v-dialog persistent v-model="isShowUpdateDataStepDialog">
            <v-stepper v-model="stepNumber">
              <v-stepper-header>
                <v-stepper-step :complete="stepNumber > 1" step="1" :editable="stepNumber > 1">
                  {{ $t('installation_notice_step_bar2') }}
                </v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step :complete="stepNumber > 2" step="2" :editable="stepNumber > 2">
                  修改資料
                </v-stepper-step>
              </v-stepper-header>

              <v-stepper-items>
                <v-stepper-content step="1">
                  <v-card class="overflow-hidden mx-5 mb-5">
                    <v-card-text>
                      <v-row>
                        <v-col>
                          <v-text-field
                            :label="$t('quotation_number')"
                            v-model="searchQuotationNumber"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                  <v-data-table
                    :headers="selectedNotWorkInstallationNoticeDataTableHeaders"
                    :items="filterNoticeList"
                    item-key="Number"
                    class="elevation-1 mx-5"
                    show-select
                    v-model="selectedWork"
                    :loading-text="$t('common_get_data')"
                    :no-data-text="$t('common_no_data')"
                    :no-results-text="$t('common_no_results')"
                    hide-default-footer
                    disable-pagination
                    :header-props="headerProps"
                  >
                  </v-data-table>
                  <div style="margin-top:30px">
                    <v-btn class="ml-2" color="red" text @click="closeShowUpdateDataStepDialog">
                      {{ $t('common_close') }}
                    </v-btn>
                    <v-btn color="green" text @click="checkSelectedUpdateData">
                      {{ $t('common_next') }}
                    </v-btn>
                  </div>
                  <v-dialog v-model="isSelectWorkNullDialog" max-width="500" persistent>
                    <v-card color="error">
                      <v-card-title class="text-h1"></v-card-title>
                      <v-card-text class="white--text text-h5">
                        <v-icon class="white--text text--lighten-1">mdi-alert-octagon</v-icon>
                        {{ $t('installation_notice_next_alert') }}
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="white" text @click="isSelectWorkNullDialog = false">
                          {{ $t('common_close') }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-stepper-content>

                <v-stepper-content step="2">
                  <v-container>
                    <ValidationObserver ref="dialogEditedInstallationNotice">
                      <v-row>
                        <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                          <ValidationProvider
                            :name="$t('fix_zone')"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <v-autocomplete
                              :items="zoneList"
                              item-text="Name"
                              item-value="Type"
                              :loading-text="$t('common_get_data')"
                              :no-data-text="$t('common_no_results')"
                              v-model="editedInstallationNotice.ZoneType"
                              :error-messages="errors[0]"
                              :disabled="isAllTextFieldDisable || editedInstallationNotice.IsWork"
                              @keyup.enter="setZoneAutocomplete"
                              ref="zoneAutocomplete"
                            >
                              <template v-slot:label>
                                <span class="red--text">
                                  <strong>* </strong>
                                </span>
                                {{ $t('fix_zone') }}
                              </template>
                            </v-autocomplete>
                          </ValidationProvider>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                          <v-text-field
                            v-model="editedInstallationNotice.CarPlace"
                            :label="$t('quotation_car_place')"
                            :disabled="isAllTextFieldDisable || editedInstallationNotice.IsWork"
                            @keyup.enter="focusNextInput"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                          <v-autocomplete
                            :items="allSpecialNeedList"
                            item-text="Name"
                            item-value="Name"
                            :label="$t('quotation_special_need')"
                            :disabled="isAllTextFieldDisable || editedInstallationNotice.IsWork"
                            v-model="editedInstallationNotice.SpecialNeedList"
                            :loading-text="$t('common_get_data')"
                            :no-data-text="$t('common_no_results')"
                            small-chips
                            multiple
                            return-object
                            @keydown.enter="setKeyDownAutocomplete"
                            @keyup.enter="setKeyUpAutocomplete"
                            ref="specialNeedAutocomplete"
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                          <v-text-field
                            v-model="editedInstallationNotice.Brand"
                            label="廠牌/車型"
                            :disabled="isAllTextFieldDisable"
                          >
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="2" sm="2" md="2" lg="2" xl="2" class="blue--text">
                          {{ $t('engineer_first_contact') }}
                        </v-col>
                        <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                          <ValidationProvider
                            :name="$t('installation_notice_contact_name')"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <v-text-field
                              v-model="editedInstallationNotice.FirstContactName"
                              :disabled="isAllTextFieldDisable || editedInstallationNotice.IsWork"
                              @keyup.enter="focusNextInput"
                              :error-messages="errors[0]"
                            >
                              <template v-slot:label>
                                <span class="red--text">
                                  <strong>* </strong>
                                </span>
                                {{ $t('installation_notice_contact_name') }}
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                          <ValidationProvider
                            :name="$t('installation_notice_contact_name')"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <v-text-field
                              v-model="editedInstallationNotice.FirstContactPhone"
                              :disabled="isAllTextFieldDisable || editedInstallationNotice.IsWork"
                              @keyup.enter="focusNextInput"
                              :error-messages="errors[0]"
                            >
                              <template v-slot:label>
                                <span class="red--text">
                                  <strong>* </strong>
                                </span>
                                {{ $t('installation_notice_contact_phone') }}
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="2" sm="2" md="2" lg="2" xl="2" class="blue--text">
                          {{ $t('engineer_second_contact') }}
                        </v-col>
                        <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                          <v-text-field
                            v-model="editedInstallationNotice.SecondContactName"
                            :label="$t('installation_notice_contact_name')"
                            :disabled="isAllTextFieldDisable || editedInstallationNotice.IsWork"
                            @keyup.enter="focusNextInput"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                          <v-text-field
                            v-model="editedInstallationNotice.SecondContactPhone"
                            :label="$t('installation_notice_contact_phone')"
                            :disabled="isAllTextFieldDisable || editedInstallationNotice.IsWork"
                            @keyup.enter="focusNextInput"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="2" sm="2" md="2" lg="2" xl="2" class="blue--text">
                          {{ $t('engineer_third_contact') }}
                        </v-col>
                        <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                          <v-text-field
                            v-model="editedInstallationNotice.ThirdContactName"
                            :label="$t('installation_notice_contact_name')"
                            :disabled="isAllTextFieldDisable || editedInstallationNotice.IsWork"
                            @keyup.enter="focusNextInput"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                          <v-text-field
                            v-model="editedInstallationNotice.ThirdContactPhone"
                            :label="$t('installation_notice_contact_phone')"
                            :disabled="isAllTextFieldDisable || editedInstallationNotice.IsWork"
                            @keyup.enter="focusNextInput"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-textarea
                            outlined
                            v-model="editedInstallationNotice.Remark"
                            label="派單備註"
                            :disabled="isAllTextFieldDisable"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                    </ValidationObserver>
                  </v-container>
                  <div style="margin-top:30px">
                    <v-btn class="ml-2" text color="red" @click="closeShowUpdateDataStepDialog">
                      {{ $t('common_close') }}
                    </v-btn>
                    <v-btn color="green" text @click="updateSelectData">
                      {{ $t('common_confirm') }}
                    </v-btn>
                  </div>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </v-dialog>
          <v-btn color="primary" dark class="mb-2 ml-8" @click="manyWork">
            {{ $t('installation_notice_many_work') }}
          </v-btn>
          <v-dialog persistent v-model="isShowStepDialog">
            <v-stepper v-model="stepNumber">
              <v-stepper-header>
                <v-stepper-step :complete="stepNumber > 1" step="1" :editable="stepNumber > 1">
                  {{ $t('installation_notice_step_bar1') }}
                </v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step :complete="stepNumber > 2" step="2" :editable="stepNumber > 2">
                  {{ $t('installation_notice_step_bar2') }}
                </v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step step="3" :editable="stepNumber > 3">
                  {{ $t('installation_notice_step_bar3') }}
                </v-stepper-step>
              </v-stepper-header>

              <v-stepper-items>
                <v-stepper-content step="1">
                  <v-row>
                    <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                      <ValidationObserver ref="dialogStepOne">
                        <ValidationProvider
                          :name="$t('installation_notice_engineer')"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-autocomplete
                            :items="maintenanceEngineers"
                            v-model="selectMaintenanceEngineer"
                            item-text="NickName"
                            item-value="UserName"
                            :error-messages="errors[0]"
                            :loading-text="$t('common_get_data')"
                            :no-data-text="$t('common_no_results')"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              {{ $t('installation_notice_engineer') }}
                            </template>
                          </v-autocomplete>
                        </ValidationProvider>
                      </ValidationObserver>
                    </v-col>
                  </v-row>
                  <div style="margin-top:30px">
                    <v-btn class="ml-2" color="red" text @click="closeStepDialog">
                      {{ $t('common_close') }}
                    </v-btn>
                    <v-btn color="green" text @click="giveMaintenanceEngineer">
                      {{ $t('common_next') }}
                    </v-btn>
                  </div>
                </v-stepper-content>
                <v-stepper-content step="2">
                  <v-text-field
                    v-model="searchNotWorkInstallationNoticeList"
                    append-icon="mdi-magnify"
                    :label="$t('installation_notice_item_card_title')"
                    single-line
                    hide-details
                    class="mb-5"
                  ></v-text-field>
                  <v-data-table
                    :headers="selectedNotWorkInstallationNoticeDataTableHeaders"
                    :items="notWorkInstallationNoticeList"
                    item-key="Number"
                    class="elevation-1"
                    show-select
                    v-model="selectedWork"
                    :loading-text="$t('common_get_data')"
                    :no-data-text="$t('common_no_data')"
                    :no-results-text="$t('common_no_results')"
                    hide-default-footer
                    disable-pagination
                    :search="searchNotWorkInstallationNoticeList"
                    :header-props="headerProps"
                  >
                  </v-data-table>
                  <div style="margin-top:30px">
                    <v-btn class="ml-2" color="red" text @click="closeStepDialog">
                      {{ $t('common_close') }}
                    </v-btn>
                    <v-btn color="green" text @click="checkSelected">
                      {{ $t('common_next') }}
                    </v-btn>
                  </div>
                  <v-dialog v-model="isSelectWorkNullDialog" max-width="500" persistent>
                    <v-card color="error">
                      <v-card-title class="text-h1"></v-card-title>
                      <v-card-text class="white--text text-h5">
                        <v-icon class="white--text text--lighten-1">mdi-alert-octagon</v-icon>
                        {{ $t('installation_notice_next_alert') }}
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="white" text @click="isSelectWorkNullDialog = false">
                          {{ $t('common_close') }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-stepper-content>

                <v-stepper-content step="3">
                  <v-data-table
                    :headers="installationNoticeDataTableHeaders"
                    :items="selectedWork"
                    item-key="Number"
                    class="elevation-1"
                    :loading-text="$t('common_get_data')"
                    :no-data-text="$t('common_no_data')"
                    :no-results-text="$t('common_no_results')"
                    hide-default-footer
                    disable-pagination
                    :header-props="headerProps"
                  >
                    <template v-slot:top>
                      <v-dialog
                        v-model="isShowNotWorkEditInstallationNoticeDialog"
                        persistent
                        max-width="600px"
                      >
                        <v-card>
                          <v-card-title>
                            <span class="text-h5">{{
                              $t('installation_notice_step_card_title')
                            }}</span>
                          </v-card-title>
                          <v-card-text>
                            <v-container>
                              <v-row>
                                <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                  <v-text-field
                                    :label="$t('installation_notice_else_point')"
                                    v-model="editedInstallationNotice.ElsePoint"
                                    @keyup.enter="focusNextInput"
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                  <v-text-field
                                    :label="$t('installation_notice_else_point_reason')"
                                    v-model="editedInstallationNotice.ElsePointReason"
                                    v-if="editedInstallationNotice.ElsePoint != 0"
                                    @keyup.enter="focusNextInput"
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                              color="red darken-1"
                              text
                              @click="closeUpdateEditedInstallationNoticePoint"
                            >
                              {{ $t('common_close') }}
                            </v-btn>
                            <v-btn
                              color="green darken-1"
                              text
                              @click="updateEditedInstallationNoticePoint"
                            >
                              {{ $t('common_confirm') }}
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </template>
                    <template v-slot:[`item.Edit`]="{ item }">
                      <v-btn icon @click="isShowNotWorkEditInstallationNoticeDialogBtn(item)">
                        <v-icon small>
                          mdi-pencil
                        </v-icon>
                      </v-btn>
                    </template>
                    <template v-slot:[`item.SpecialNeedList`]="{ item }">
                      {{ turnSpecialNeedName(item.SpecialNeedList) }}
                    </template>
                    <template v-slot:[`item.ZoneType`]="{ item }">
                      {{ turnZoneTypeName(item.ZoneType) }}
                    </template>
                  </v-data-table>
                  <div style="margin-top:30px">
                    <v-btn class="ml-2" text color="red" @click="closeStepDialog">
                      {{ $t('common_close') }}
                    </v-btn>
                    <v-btn color="green" text @click="manyPointAndMaintenanceEngineerUpdate">
                      {{ $t('installation_notice_is_work') }}
                    </v-btn>
                  </div>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </v-dialog>
          <v-dialog v-model="isShowEditInstallationNoticeDialog" fullscreen persistent>
            <!-- <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    dark
                    class="mb-2 ml-8"
                    v-bind="attrs"
                    v-on="on"
                  >
                    {{ $t("bom_new_btn") }}
                  </v-btn>
                </template> -->
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ $t('installation_notice_card_title') }}</span>
              </v-card-title>
              <v-card-text>
                <v-row class="mt-2">
                  <v-btn
                    color="primary"
                    @click="isWorkBtn"
                    :disabled="
                      editedInstallationNotice.IsWork ||
                        editedInstallationNotice.IsCancel ||
                        editedInstallationNotice.IsThrowToResume
                    "
                    class="mx-2"
                  >
                    {{ $t('installation_notice_is_work') }}
                  </v-btn>
                  <!-- <v-btn
                    color="primary"
                    @click="isShowThrowDialog = true"
                    :disabled="
                      editedInstallationNotice.IsCancel ||
                        editedInstallationNotice.IsWork ||
                        editedInstallationNotice.IsThrowToResume
                    "
                    class="mx-2"
                  >
                    轉拋履歷卡
                  </v-btn>
                  <v-dialog v-model="isShowThrowDialog" persistent>
                    <v-card>
                      <v-card-title class="text-h5"></v-card-title>
                      <v-card-text>
                        <ValidationObserver ref="setDoneTime">
                          <v-row>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <date-picker-set-time
                                :time="editedInstallationNotice.DoneTime"
                                :dateName="'month_quotation_done_time'"
                                :isAllTextFieldDisabled="isAllTextFieldDisable"
                                @setDate="setDoneTime"
                                @keyupEnter="focusNextInput"
                              />
                            </v-col>
                          </v-row>
                        </ValidationObserver>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click="isShowThrowDialog = false">
                          {{ $t('common_cancel') }}
                        </v-btn>
                        <v-btn color="green darken-1" text @click="isThrowResumeBtn">
                          {{ $t('common_confirm') }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog> -->
                  <v-btn
                    color="primary"
                    @click="isShowCancelDialog = true"
                    :disabled="
                      editedInstallationNotice.IsCancel ||
                        editedInstallationNotice.IsWork ||
                        editedInstallationNotice.IsThrowToResume
                    "
                    class="mx-2"
                  >
                    {{ $t('common_cancel') }}
                  </v-btn>
                  <v-dialog v-model="isShowCancelDialog" persistent>
                    <v-card>
                      <v-card-title class="text-h5">
                        填寫取消原因
                      </v-card-title>
                      <v-card-text>
                        <v-textarea
                          outlined
                          v-model="returnReason.Reason"
                          label="取消原因"
                        ></v-textarea>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click="isShowCancelDialog = false">
                          {{ $t('common_cancel') }}
                        </v-btn>
                        <v-btn color="green darken-1" text @click="isCancelBtn">
                          {{ $t('common_confirm') }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-spacer></v-spacer>
                  <div
                    style="color:red; margin-right:100px"
                    v-if="editedInstallationNotice.IsCancel"
                  >
                    <v-icon color="error">
                      mdi-alert-box
                    </v-icon>
                    已取消
                  </div>
                  <div
                    style="color:green; margin-right:100px"
                    v-if="editedInstallationNotice.IsThrowToResume"
                  >
                    <v-icon color="success">
                      mdi-checkbox-marked-outline
                    </v-icon>
                    已轉拋
                  </div>
                  <div
                    style="color:red; margin-right:100px"
                    v-if="
                      !editedInstallationNotice.IsWork &&
                        !editedInstallationNotice.IsCancel &&
                        !editedInstallationNotice.IsThrowToResume
                    "
                  >
                    <v-icon color="error">
                      mdi-alert-box
                    </v-icon>
                    {{ $t('installation_notice_status_false') }}
                  </div>
                  <div
                    style="color:green; margin-right:100px"
                    v-if="editedInstallationNotice.IsWork"
                  >
                    <v-icon color="success">
                      mdi-checkbox-marked-outline
                    </v-icon>
                    {{ $t('installation_notice_status_true') }}
                  </div>
                </v-row>
              </v-card-text>
              <v-tabs>
                <v-tab href="#tab-1">{{ $t('app_basic_information') }}</v-tab>
                <v-tab href="#tab-2">{{ $t('installation_notice_record') }}</v-tab>
                <v-tab-item value="tab-1">
                  <v-card flat>
                    <v-card-text>
                      <v-container>
                        <ValidationObserver ref="dialogEditedInstallationNotice">
                          <v-row>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <v-text-field
                                v-model="turnNoticeType"
                                :label="$t('installation_notice_type')"
                                disabled
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <v-text-field
                                v-model="editedInstallationNotice.Number"
                                :label="$t('installation_notice_number')"
                                disabled
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <v-text-field
                                v-model="turnCreateTime"
                                :label="$t('installation_notice_create_time')"
                                disabled
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <v-text-field
                                v-model="editedInstallationNotice.CustomerNumber"
                                :label="$t('quotation_customer_number')"
                                disabled
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <v-text-field
                                v-model="editedInstallationNotice.CustomerName"
                                :label="$t('quotation_shortname')"
                                disabled
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <v-text-field
                                v-model="editedInstallationNotice.CustomerFullName"
                                :label="$t('quotation_full_name')"
                                disabled
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <ValidationProvider
                                :name="$t('fix_zone')"
                                rules="required"
                                v-slot="{ errors }"
                              >
                                <v-autocomplete
                                  :items="zoneList"
                                  item-text="Name"
                                  item-value="Type"
                                  :loading-text="$t('common_get_data')"
                                  :no-data-text="$t('common_no_results')"
                                  v-model="editedInstallationNotice.ZoneType"
                                  :error-messages="errors[0]"
                                  :disabled="
                                    isAllTextFieldDisable || editedInstallationNotice.IsWork
                                  "
                                  @keyup.enter="setZoneAutocomplete"
                                  ref="zoneAutocomplete"
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    {{ $t('fix_zone') }}
                                  </template>
                                </v-autocomplete>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <v-text-field
                                v-model="editedInstallationNotice.CarPlace"
                                :label="$t('quotation_car_place')"
                                :disabled="isAllTextFieldDisable || editedInstallationNotice.IsWork"
                                @keyup.enter="focusNextInput"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <v-autocomplete
                                :items="allSpecialNeedList"
                                item-text="Name"
                                item-value="Name"
                                :label="$t('quotation_special_need')"
                                :disabled="isAllTextFieldDisable || editedInstallationNotice.IsWork"
                                v-model="editedInstallationNotice.SpecialNeedList"
                                :loading-text="$t('common_get_data')"
                                :no-data-text="$t('common_no_results')"
                                small-chips
                                multiple
                                return-object
                                @keydown.enter="setKeyDownAutocomplete"
                                @keyup.enter="setKeyUpAutocomplete"
                                ref="specialNeedAutocomplete"
                              ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                              <v-text-field
                                v-model="editedInstallationNotice.Brand"
                                label="廠牌/車型"
                                :disabled="isAllTextFieldDisable"
                              >
                              </v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="2" sm="2" md="2" lg="2" xl="2" class="blue--text">
                              {{ $t('engineer_first_contact') }}
                            </v-col>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <ValidationProvider
                                :name="$t('installation_notice_contact_name')"
                                rules="required"
                                v-slot="{ errors }"
                              >
                                <v-text-field
                                  v-model="editedInstallationNotice.FirstContactName"
                                  :disabled="
                                    isAllTextFieldDisable || editedInstallationNotice.IsWork
                                  "
                                  @keyup.enter="focusNextInput"
                                  :error-messages="errors[0]"
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    {{ $t('installation_notice_contact_name') }}
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <ValidationProvider
                                :name="$t('installation_notice_contact_name')"
                                rules="required"
                                v-slot="{ errors }"
                              >
                                <v-text-field
                                  v-model="editedInstallationNotice.FirstContactPhone"
                                  :disabled="
                                    isAllTextFieldDisable || editedInstallationNotice.IsWork
                                  "
                                  @keyup.enter="focusNextInput"
                                  :error-messages="errors[0]"
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    {{ $t('installation_notice_contact_phone') }}
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="2" sm="2" md="2" lg="2" xl="2" class="blue--text">
                              {{ $t('engineer_second_contact') }}
                            </v-col>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <v-text-field
                                v-model="editedInstallationNotice.SecondContactName"
                                :label="$t('installation_notice_contact_name')"
                                :disabled="isAllTextFieldDisable || editedInstallationNotice.IsWork"
                                @keyup.enter="focusNextInput"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <v-text-field
                                v-model="editedInstallationNotice.SecondContactPhone"
                                :label="$t('installation_notice_contact_phone')"
                                :disabled="isAllTextFieldDisable || editedInstallationNotice.IsWork"
                                @keyup.enter="focusNextInput"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="2" sm="2" md="2" lg="2" xl="2" class="blue--text">
                              {{ $t('engineer_third_contact') }}
                            </v-col>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <v-text-field
                                v-model="editedInstallationNotice.ThirdContactName"
                                :label="$t('installation_notice_contact_name')"
                                :disabled="isAllTextFieldDisable || editedInstallationNotice.IsWork"
                                @keyup.enter="focusNextInput"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <v-text-field
                                v-model="editedInstallationNotice.ThirdContactPhone"
                                :label="$t('installation_notice_contact_phone')"
                                :disabled="isAllTextFieldDisable || editedInstallationNotice.IsWork"
                                @keyup.enter="focusNextInput"
                              ></v-text-field>
                            </v-col>
                          </v-row>

                          <v-row>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <ValidationProvider
                                :name="$t('quotation_license_plate')"
                                :rules="{ required: true }"
                                v-slot="{ errors }"
                              >
                                <v-text-field
                                  v-model="editedInstallationNotice.LicensePlate"
                                  :disabled="
                                    isAllTextFieldDisable ||
                                      editedInstallationNotice.IsWork ||
                                      editedInstallationNotice.NoticeType !== 1
                                  "
                                  :error-messages="errors[0]"
                                  @keyup.enter="focusNextInput"
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    {{ $t('quotation_license_plate') }}
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <v-text-field
                                v-model="editedInstallationNotice.OriginalLicensePlate"
                                :label="$t('quotation_original_license_plate')"
                                :disabled="
                                  isAllTextFieldDisable ||
                                    editedInstallationNotice.IsWork ||
                                    editedInstallationNotice.NoticeType !== 1
                                "
                                @keyup.enter="focusNextInput"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <v-autocomplete
                                :items="maintenanceEngineers"
                                v-model="editedInstallationNotice.MaintenanceEngineer"
                                item-text="NickName"
                                item-value="UserName"
                                :loading-text="$t('common_get_data')"
                                :no-data-text="$t('common_no_results')"
                                :disabled="isAllTextFieldDisable || editedInstallationNotice.IsWork"
                                @keyup.enter="setEngineerAutocomplete"
                                ref="engineerAutocomplete"
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  {{ $t('installation_notice_engineer') }}
                                </template>
                              </v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <ValidationProvider
                                :name="$t('installation_notice_point')"
                                :rules="{ required: true }"
                                v-slot="{ errors }"
                              >
                                <v-text-field
                                  v-model="editedInstallationNotice.Point"
                                  disabled
                                  :error-messages="errors[0]"
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    {{ $t('installation_notice_point') }}
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <v-text-field
                                v-model="editedInstallationNotice.ElsePoint"
                                :label="$t('installation_notice_else_point')"
                                :disabled="isAllTextFieldDisable || editedInstallationNotice.IsWork"
                                @keyup.enter="focusNextInput"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <ValidationProvider
                                :name="$t('installation_notice_else_point_reason')"
                                v-if="editedInstallationNotice.ElsePoint != 0"
                                :rules="{ required: true }"
                                v-slot="{ errors }"
                              >
                                <v-text-field
                                  v-model="editedInstallationNotice.ElsePointReason"
                                  v-if="editedInstallationNotice.ElsePoint != 0"
                                  :disabled="
                                    isAllTextFieldDisable || editedInstallationNotice.IsWork
                                  "
                                  :error-messages="errors[0]"
                                  required
                                  @keyup.enter="focusNextInput"
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    {{ $t('installation_notice_else_point_reason') }}
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                          </v-row>
                        </ValidationObserver>
                        <!-- <v-row>
                          <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                            <v-text-field
                              v-model="editedInstallationNotice.SaleNumber"
                              :label="$t('installation_notice_sale_number')"
                              disabled
                            ></v-text-field>
                          </v-col>
                        </v-row> -->
                        <v-row>
                          <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                            <v-text-field
                              v-model="turnWorkDate"
                              :label="$t('installation_notice_work_date')"
                              disabled
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                            <v-text-field
                              v-model="turnWorkBy"
                              :label="$t('installation_notice_work_by')"
                              disabled
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col>
                            <v-textarea
                              outlined
                              v-model="editedInstallationNotice.Remark"
                              label="派單備註"
                              :disabled="isAllTextFieldDisable"
                            ></v-textarea>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-data-table
                      :headers="installationNoticeItemDataTableHeaders"
                      :items="editedInstallationNotice.InstallationNoticeItems"
                      class="elevation-1 my-5 mx-5"
                      :search="searchInstallationNoticeItem"
                      :loading-text="$t('common_get_data')"
                      :no-data-text="$t('common_no_data')"
                      :no-results-text="$t('common_no_results')"
                      :footer-props="{
                        'items-per-page-options': [30, 50, 100],
                        'items-per-page-text': $t('item_rows_per_page'),
                      }"
                      :header-props="headerProps"
                    >
                      <template v-slot:top>
                        <v-toolbar flat>
                          <v-toolbar-title>{{
                            $t('installation_notice_item_toolbar_title')
                          }}</v-toolbar-title>
                          <v-spacer></v-spacer>
                          <v-text-field
                            v-model="searchInstallationNoticeItem"
                            append-icon="mdi-magnify"
                            :label="$t('installation_notice_item_card_title')"
                            single-line
                            hide-details
                            clearable
                          ></v-text-field>
                        </v-toolbar>
                      </template>
                      <template v-slot:[`item.InstallPosition`]="{ item }">
                        {{ turnData(item.InstallPosition) }}
                      </template>
                      <template v-slot:[`item.BuyOrRentType`]="{ item }">
                        {{ turnBuyOrRentType(item.BuyOrRentType) }}
                      </template>
                      <template v-slot:[`item.Custody`]="{ item }">
                        {{ turnCustodyTypeData(item.Custody) }}
                      </template>
                      <template v-slot:[`item.CustomerDeviceType`]="{ item }">
                        {{ turnCustomerDeviceTypeData(item.CustomerDeviceType) }}
                      </template>
                    </v-data-table>
                  </v-card>
                </v-tab-item>
                <v-tab-item value="tab-2">
                  <v-card flat>
                    <v-card-text>
                      <v-data-table
                        :headers="recordListDataTableHeaders"
                        :items="editedInstallationNotice.RecordList"
                        class="elevation-1 my-5 mx-5"
                        :loading-text="$t('common_get_data')"
                        :no-data-text="$t('common_no_data')"
                        :no-results-text="$t('common_no_results')"
                        :footer-props="{
                          'items-per-page-options': [30, 50, 100],
                          'items-per-page-text': $t('item_rows_per_page'),
                        }"
                        :header-props="headerProps"
                      >
                        <template v-slot:[`item.RecordType`]="{ item }">
                          {{ turnRecordType(item.RecordType) }}
                        </template>
                        <template v-slot:[`item.CreateTime`]="{ item }">
                          {{ convertToDateTimeFormat(item.CreateTime) }}
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="red darken-1"
                  text
                  @click="closeEditedInstallationNotice"
                  :disabled="isLoadingSaveBtn"
                >
                  {{ $t('common_cancel') }}
                </v-btn>
                <v-btn
                  color="green darken-1"
                  text
                  @click="saveEditedInstallationNotice"
                  :loading="isLoadingSaveBtn"
                  :disabled="isAllTextFieldDisable || editedInstallationNotice.IsWork"
                >
                  {{ $t('common_save') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.Edit`]="{ item }">
        <v-btn icon @click="isShowEditInstallationNoticeDialogBtn(item)">
          <v-icon small>
            mdi-pencil
          </v-icon>
        </v-btn>
      </template>
      <template v-slot:[`item.IsWork`]="{ item }">
        <v-icon v-if="item.IsWork">
          mdi-check
        </v-icon>
        <v-icon v-else>
          mdi-close
        </v-icon>
      </template>
      <template v-slot:[`item.ZoneType`]="{ item }">
        {{ turnZoneTypeName(item.ZoneType) }}
      </template>
      <template v-slot:[`item.SpecialNeedList`]="{ item }">
        {{ turnSpecialNeedName(item.SpecialNeedList) }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import axios from 'axios'
import {
  HttpInstallationNotice,
  HttpFix,
  HttpUser,
  HttpSpecialNeed,
  HttpInstallPosition
} from '@/js/http-Manager'
import { ItemInstallPositionType } from '@/js/ItemInstallPositionType'
import { RecordType } from '@/js/RecordType'
import { NoticeType } from '@/js/NoticeType'
import { BuyOrRentType } from '@/js/BuyOrRentType'
import { extend } from 'vee-validate'
import { regex } from 'vee-validate/dist/rules'
import CustomerAutocompleteFilter from '@/components/CustomerAutocompleteFilter.vue'
import { ZoneType } from '@/js/ZoneType'
import { CustodyType } from '@/js/CustodyType'
import { CustomerDeviceType } from '@/js/CustomerDeviceType'
// import DatePickerSetTime from '@/components/DatePickerSetTime.vue'
extend('regex', regex)
export default {
  components: {
    CustomerAutocompleteFilter // DatePickerSetTime
  },
  name: 'InstallationNotice',
  data: () => ({
    installPositionList: [],
    isShowUpdateDataStepDialog: false,
    isShowEditInstallationNoticeDialog: false,
    installationNoticeList: [],
    searchQuotationNumber: '',
    editedInstallationNoticeIndex: -1,
    editedInstallationNotice: {
      NoticeType: 0,
      Number: '',
      CustomerId: '',
      CustomerNumber: '',
      CustomerName: '',
      CustomerFullName: '',
      FirstContactName: '',
      FirstContactPhone: '',
      SecondContactName: '',
      SecondContactPhone: '',
      ThirdContactName: '',
      ThirdContactPhone: '',
      CarPlace: '',
      SaleNumber: '',
      SaleName: '',
      LicensePlate: '',
      OriginalLicensePlate: '',
      Point: 0,
      ElsePoint: 0,
      ElsePointReason: '',
      MaintenanceEngineer: '',
      IsWork: false,
      NoticeToAcceptanceThrowUsers: {
        ThrowTime: 0,
        Name: ''
      },
      InstallationNoticeItems: [],
      ErpSaleToCrmThrowUsers: [],
      ZoneType: 1,
      RecordList: [],
      SpecialNeedList: [],
      Brand: '',
      Remark: '',
      IsCancel: false,
      IsThrowToResume: false,
      DoneTime: 0
    },
    defaultInstallationNotice: {
      NoticeType: 0,
      CustomerId: '',
      Number: '',
      CustomerNumber: '',
      CustomerName: '',
      CustomerFullName: '',
      FirstContactName: '',
      FirstContactPhone: '',
      SecondContactName: '',
      SecondContactPhone: '',
      ThirdContactName: '',
      ThirdContactPhone: '',
      CarPlace: '',
      SaleNumber: '',
      SaleName: '',
      LicensePlate: '',
      OriginalLicensePlate: '',
      Point: 0,
      ElsePoint: 0,
      ElsePointReason: '',
      MaintenanceEngineer: '',
      IsWork: false,
      NoticeToAcceptanceThrowUsers: {
        ThrowTime: 0,
        Name: ''
      },
      InstallationNoticeItems: [],
      ErpSaleToCrmThrowUsers: [],
      ZoneType: 1,
      RecordList: [],
      SpecialNeedList: [],
      Brand: '',
      Remark: '',
      IsCancel: false,
      IsThrowToResume: false,
      DoneTime: 0
    },
    isInstallationNoticeLoading: true,
    isLoadingSaveBtn: false,
    isAllTextFieldDisable: false,
    updateInstallationNoticeSource: null,
    installationNoticeSomeSource: null,
    totalRows: 0,
    currentOptions: {
      // default DataTable Options
      page: 1,
      itemsPerPage: 30,
      sortBy: [],
      sortDesc: [],
      groupBy: [],
      groupDesc: [],
      multiSort: false,
      mustSort: false,
      triggerByOutsite: true
    },
    isUpdateEventTotal: true,
    filterInstallationNotice: {
      CustomerId: '',
      NoticeNumber: '',
      LicensePlate: '',
      MaintenanceEngineer: '',
      IsRange: false,
      QuotationNumber: '',
      StartQuotationNumber: '',
      EndQuotationNumber: '',
      FirstContactName: '',
      FirstContactPhone: '',
      SecondContactName: '',
      SecondContactPhone: '',
      CarPlace: '',
      ZoneType: 0,
      SpecialNeedId: ''
    },

    editedInstallationNoticeItemIndex: -1,
    searchInstallationNoticeItem: '',
    stepNumber: 1,
    isShowStepDialog: false,
    selectedWork: [],
    notWorkInstallationNoticeList: [],
    isShowNotWorkEditInstallationNoticeDialog: false,
    selectMaintenanceEngineer: '',
    isSelectWorkNullDialog: false,
    maintenanceEngineers: [],
    searchNotWorkInstallationNoticeList: '',
    zoneList: [],
    allSpecialNeedList: [],
    specialNeedList: [],
    isShowCancelDialog: false,
    returnReason: {
      Reason: '',
      Number: '',
      NumberType: 11,
      IsCancel: true
    },
    defaultReason: {
      Reason: '',
      Number: '',
      NumberType: 11,
      IsCancel: true
    },
    isShowThrowDialog: false
  }),
  watch: {},
  async mounted () {
    await this.getInstallationNotice()
    await this.countTotalRows()
    await this.getZoneType()
    await this.getEngineerUser()
    await this.getSpecialNeedList()
    await this.getInstallPositionList()
  },
  computed: {
    turnCreateTime () {
      return this.convertToDateTimeFormat(this.editedInstallationNotice.CreateTime)
    },
    installationNoticeDataTableHeaders () {
      return [
        {
          text: this.$t('installation_notice_number'),
          align: 'start',
          value: 'Number'
        },
        { text: this.$t('quotation_customer_number'), align: 'start', value: 'CustomerNumber' },
        { text: this.$t('quotation_shortname'), align: 'start', value: 'CustomerName' },
        { text: this.$t('quotation_full_name'), align: 'start', value: 'CustomerFullName' },
        { text: this.$t('quotation_license_plate'), align: 'start', value: 'LicensePlate' },
        {
          text: this.$t('quotation_original_license_plate'),
          align: 'start',
          value: 'OriginalLicensePlate'
        },
        {
          text: this.$t('installation_notice_contact_name') + '(1)',
          align: 'start',
          value: 'FirstContactName'
        },
        {
          text: this.$t('installation_notice_contact_phone') + '(1)',
          align: 'start',
          value: 'FirstContactPhone'
        },
        {
          text: this.$t('installation_notice_contact_name') + '(2)',
          align: 'start',
          value: 'SecondContactName'
        },
        {
          text: this.$t('installation_notice_contact_phone') + '(2)',
          align: 'start',
          value: 'SecondContactPhone'
        },
        {
          text: this.$t('fix_zone'),
          align: 'start',
          value: 'ZoneType'
        },
        {
          text: this.$t('quotation_car_place'),
          align: 'start',
          value: 'CarPlace'
        },
        {
          text: this.$t('installation_notice_engineer'),
          align: 'start',
          value: 'EngineerNickName'
        },
        {
          text: this.$t('quotation_special_need'),
          align: 'start',
          value: 'SpecialNeedList'
        },
        { text: this.$t('installation_notice_point'), align: 'start', value: 'Point' },
        { text: this.$t('installation_notice_else_point'), align: 'start', value: 'ElsePoint' },
        {
          text: this.$t('installation_notice_is_work'),
          align: 'center',
          value: 'IsWork',
          sortable: false
        },
        { text: this.$t('common_edit'), align: 'center', value: 'Edit', sortable: false }
      ]
    },
    selectedNotWorkInstallationNoticeDataTableHeaders () {
      return [
        {
          text: this.$t('installation_notice_number'),
          align: 'start',
          value: 'Number'
        },
        { text: this.$t('quotation_customer_number'), align: 'start', value: 'CustomerNumber' },
        { text: this.$t('quotation_shortname'), align: 'start', value: 'CustomerName' },
        { text: this.$t('quotation_full_name'), align: 'start', value: 'CustomerFullName' },
        { text: this.$t('quotation_license_plate'), align: 'start', value: 'LicensePlate' },
        {
          text: this.$t('quotation_original_license_plate'),
          align: 'start',
          value: 'OriginalLicensePlate'
        },
        {
          text: this.$t('installation_notice_engineer'),
          align: 'start',
          value: 'EngineerNickName'
        },
        {
          text: this.$t('quotation_number'),
          align: 'start',
          value: 'QuotationNumber'
        },
        {
          text: this.$t('installation_notice_is_work'),
          align: 'center',
          value: 'IsWork',
          sortable: false
        }
      ]
    },
    installationNoticeItemDataTableHeaders () {
      return [
        { text: this.$t('installation_notice_item_main_name'), align: 'start', value: 'BomName' },
        { text: this.$t('quotation_item_number'), align: 'start', value: 'Number' },
        { text: this.$t('quotation_item_name'), align: 'start', value: 'Name' },
        { text: this.$t('quotation_item_unit'), align: 'start', value: 'Unit' },
        { text: this.$t('quotation_item_quantity'), align: 'end', value: 'Quantity' },
        {
          text: this.$t('installation_notice_item_buy_or_rent'),
          align: 'start',
          value: 'BuyOrRentType'
        },
        {
          text: this.$t('quotation_item_serialnumber'),
          align: 'start',
          value: 'SerialNumber'
        },
        { text: this.$t('quotation_item_warranty_period'), align: 'end', value: 'WarrantyPeriod' },
        {
          text: this.$t('quotation_item_is_customer_device'),
          align: 'start',
          value: 'CustomerDeviceType'
        },
        {
          text: this.$t('resume_item_custody'),
          align: 'start',
          value: 'Custody'
        },
        {
          text: this.$t('quotation_item_install_position'),
          align: 'start',
          value: 'InstallPosition'
        }
      ]
    },
    turnWorkDate () {
      return this.convertToDateTimeFormat(
        this.editedInstallationNotice.NoticeToAcceptanceThrowUsers.ThrowTime
      )
    },
    turnWorkBy () {
      return this.editedInstallationNotice.NoticeToAcceptanceThrowUsers.Name
    },
    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    },
    turnNoticeType () {
      return NoticeType.getFormNoticeTypeName(this.editedInstallationNotice.NoticeType)
    },
    recordListDataTableHeaders () {
      return [
        {
          text: this.$t('installation_notice_work_by'),
          align: 'start',
          value: 'WorkNickName'
        },
        {
          text: this.$t('month_item_status'),
          align: 'start',
          value: 'RecordType'
        },
        {
          text: this.$t('installation_notice_engineer'),
          align: 'start',
          value: 'EngineerNickName'
        },
        {
          text: this.$t('installation_notice_engineer_number'),
          align: 'start',
          value: 'Number'
        },
        {
          text: this.$t('installation_notice_time'),
          align: 'start',
          value: 'CreateTime'
        },
        {
          text: this.$t('installation_notice_reason'),
          align: 'start',
          value: 'Reason'
        }
      ]
    },
    filterNoticeList () {
      return this.searchQuotationNumber
        ? this.notWorkInstallationNoticeList.filter((x) =>
          x.QuotationNumber.includes(this.searchQuotationNumber)
        )
        : this.notWorkInstallationNoticeList
    }
  },
  methods: {
    setDoneTime (val) {
      this.editedInstallationNotice.DoneTime = val * 1
    },
    async isThrowResumeBtn () {
      const isValid = await this.$refs.setDoneTime.validate()
      if (isValid) {
        this.editedInstallationNotice.IsThrowToResume = true
        let response = await HttpInstallationNotice.ThrowToResume(this.editedInstallationNotice)
        if (response && response.status === 200) {
          await this.getInstallationNotice()
          this.closeEditedInstallationNotice()
          this.isShowThrowDialog = false
        }
      }
    },
    async isCancelBtn () {
      this.returnReason.Number = this.editedInstallationNotice.Number
      this.returnReason.IsCancel = true
      await HttpInstallationNotice.UpdateCancelReason(this.returnReason)
      this.returnReason = JSON.parse(JSON.stringify(this.defaultReason))
      await this.getInstallationNotice()
      this.closeEditedInstallationNotice()
      this.isShowCancelDialog = false
    },
    async isShowUpdateDataStepDialogBtn () {
      await this.getNotInstallationNotice()
      this.isShowUpdateDataStepDialog = true
    },
    closeShowUpdateDataStepDialog () {
      this.isShowUpdateDataStepDialog = false
      this.selectedWork = []
      this.stepNumber = 1
      this.searchQuotationNumber = ''
      this.$nextTick(() => {
        this.editedInstallationNotice = JSON.parse(JSON.stringify(this.defaultInstallationNotice))
      })
    },
    checkSelectedUpdateData () {
      if (this.selectedWork.length !== 0) {
        this.stepNumber = 2
      } else {
        this.isSelectWorkNullDialog = true
      }
    },
    async updateSelectData () {
      const isValid = await this.$refs.dialogEditedInstallationNotice.validate()
      if (isValid) {
        let array = []
        this.selectedWork.forEach((element) => {
          array.push(element.Id)
        })
        let param = Object.assign({ SelectNoticeIds: array }, this.editedInstallationNotice)
        await HttpInstallationNotice.UpdateSelectDataList(param)
        await this.getInstallationNotice()
        this.closeShowUpdateDataStepDialog()
      }
    },

    turnCustomerDeviceTypeData (val) {
      return CustomerDeviceType.CustomerDeviceTypeName(val)
    },
    turnCustodyTypeData (val) {
      return CustodyType.CustodyTypeName(val)
    },
    setEngineerAutocomplete (event) {
      this.$refs.engineerAutocomplete.isMenuActive = false
      this.$refs.engineerAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setZoneAutocomplete (event) {
      this.$refs.zoneAutocomplete.isMenuActive = false
      this.$refs.zoneAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setKeyDownAutocomplete () {
      ///  儲存keydown之前的Roles
      this.specialNeedList = this.editedInstallationNotice.SpecialNeedList
    },
    setKeyUpAutocomplete (event) {
      this.$refs.specialNeedAutocomplete.isMenuActive = false
      this.$refs.specialNeedAutocomplete.isFocused = false
      ///  塞回keydown之前的Roles  給KeyUp的Model editedUser.Roles
      this.editedInstallationNotice.SpecialNeedList = this.specialNeedList
      this.focusNextInput(event)
    },
    focusNextInput (event) {
      let form = document.getElementsByTagName('input')
      let targets = []
      for (let i = 0; i < form.length; i++) {
        if (
          form[i].type !== 'hidden' &&
          !form[i].disabled &&
          !form[i].readOnly &&
          form[i].type !== 'checkbox'
        ) {
          targets.push(form[i])
        }
      }
      let index = Array.prototype.indexOf.call(targets, event.target)
      if (index !== -1) {
        let next = index + 1
        if (next < targets.length) {
          targets[next].focus()
          targets[next].select()
        }
      }
    },
    turnSpecialNeedName (value) {
      if (value) {
        let str = []
        let temp = 0
        value.forEach((element) => {
          str.push(element.Name)
          temp++
        })
        str = JSON.stringify(str)
        str = str.replace('[', '').replace(']', '')
        for (let index = 0; index < temp * 2; index++) {
          str = str.replace('"', '')
        }
        return str
      }
    },
    async getSpecialNeedList () {
      let response = await HttpSpecialNeed.GetSpecialNeed()
      this.allSpecialNeedList = response.status === 200 ? response.data.Data : []
    },
    turnRecordType (item) {
      return RecordType.RecordTypeName(item)
    },
    async getEngineerUser () {
      let response = await HttpUser.GetEngineerUser()
      this.maintenanceEngineers = response.status === 200 ? response.data.Data : []
    },
    turnZoneTypeName (val) {
      return ZoneType.ZoneTypeName(val)
    },
    async getZoneType () {
      let response = await HttpFix.GetZoneType()
      this.zoneList = response.status === 200 ? response.data.Data : 0
    },
    async changeLicensePlate (item) {
      let index = this.installationNoticeList.indexOf(item)
      await HttpInstallationNotice.UpdateNotice(this.installationNoticeList[index])
      await this.getInstallationNotice()
    },
    async setIsChange () {
      this.filterInstallationNotice.QuotationNumber = ''
      this.filterInstallationNotice.StartQuotationNumber = ''
      this.filterInstallationNotice.EndQuotationNumber = ''
      await this.getInstallationNotice()
    },
    async manyWork () {
      await this.getNotInstallationNotice()
      this.isShowStepDialog = true
    },
    async setFilterCustomer (val) {
      this.filterInstallationNotice.CustomerId = val.Id
      this.filterInstallationNotice = JSON.parse(JSON.stringify(this.filterInstallationNotice))
      await this.getInstallationNotice()
      await this.countTotalRows()
    },
    turnData (value) {
      return ItemInstallPositionType.getFormInstallPositionTypeName(
        value,
        this.installPositionList
      )
    },
    async getInstallPositionList () {
      let response = await HttpInstallPosition.GetAllInstallPosition()
      this.installPositionList = response && response.status === 200 ? response.data.Data : []
    },

    turnBuyOrRentType (val) {
      return BuyOrRentType.BuyOrRentTypeName(val)
    },
    checkSelected () {
      if (this.selectedWork.length !== 0) {
        this.stepNumber = 3
      } else {
        this.isSelectWorkNullDialog = true
      }
    },
    async manyPointAndMaintenanceEngineerUpdate () {
      await HttpInstallationNotice.UpdateNoticeList(this.selectedWork)
      await HttpInstallationNotice.ThrowManyToAcceptance(this.selectedWork)
      await this.getInstallationNotice()
      this.closeStepDialog()
    },
    updateEditedInstallationNoticePoint () {
      this.selectedWork.splice(
        this.editedInstallationNoticeIndex,
        1,
        this.editedInstallationNotice
      )
      this.closeUpdateEditedInstallationNoticePoint()
    },
    closeUpdateEditedInstallationNoticePoint () {
      this.isShowNotWorkEditInstallationNoticeDialog = false
    },
    async giveMaintenanceEngineer () {
      const isValid = await this.$refs.dialogStepOne.validate()
      if (isValid) {
        this.stepNumber = 2
        this.notWorkInstallationNoticeList.forEach((element) => {
          element.MaintenanceEngineer = this.selectMaintenanceEngineer
          element.EngineerNickName = this.maintenanceEngineers.find(
            (x) => x.UserName === this.selectMaintenanceEngineer
          ).NickName
        })
      }
    },
    isShowNotWorkEditInstallationNoticeDialogBtn (item) {
      this.editedInstallationNoticeIndex = this.selectedWork.indexOf(item)
      let str = JSON.stringify(item)
      this.editedInstallationNotice = JSON.parse(str)
      this.isShowNotWorkEditInstallationNoticeDialog = true
    },
    closeStepDialog () {
      this.isShowStepDialog = false
      this.selectedWork = []
      this.stepNumber = 1
      this.selectMaintenanceEngineer = ''
      this.$nextTick(() => {
        let str = JSON.stringify(this.defaultInstallationNotice)
        this.editedInstallationNotice = JSON.parse(str)
        this.editedInstallationNoticeIndex = -1
      })
    },
    async isWorkBtn () {
      if (this.editedInstallationNotice.MaintenanceEngineer) {
        this.editedInstallationNotice.IsWork = true
        await HttpInstallationNotice.UpdateNotice(this.editedInstallationNotice)
        await HttpInstallationNotice.ThrowToAcceptance(this.editedInstallationNotice)
        await this.getInstallationNotice()
        this.closeEditedInstallationNotice()
      } else {
        alert('請填寫工程師')
      }
    },
    async countTotalRows () {
      if (this.isUpdateEventTotal) {
        let param = {
          noticeNumber: this.filterInstallationNotice.NoticeNumber,
          customerId: this.filterInstallationNotice.CustomerId,
          licensePlate: this.filterInstallationNotice.LicensePlate,
          maintenanceEngineer: this.filterInstallationNotice.MaintenanceEngineer,
          quotationNumber: this.filterInstallationNotice.QuotationNumber,
          startQuotationNumber: this.filterInstallationNotice.StartQuotationNumber,
          endQuotationNumber: this.filterInstallationNotice.EndQuotationNumber,
          isRange: this.filterInstallationNotice.IsRange,
          firstContactName: this.filterInstallationNotice.FirstContactName,
          firstContactPhone: this.filterInstallationNotice.FirstContactPhone,
          secondContactName: this.filterInstallationNotice.SecondContactName,
          secondContactPhone: this.filterInstallationNotice.SecondContactPhone,
          carPlace: this.filterInstallationNotice.CarPlace,
          zoneType: this.filterInstallationNotice.ZoneType,
          specialNeedId: this.filterInstallationNotice.SpecialNeedId
        }
        if (this.countTotalRowsSource) {
          this.countTotalRowsSource.cancel('cancel')
        }
        let cancelToken = axios.CancelToken
        this.countTotalRowsSource = cancelToken.source()
        let response = await HttpInstallationNotice.GetNoticesCount(
          param,
          this.countTotalRowsSource.token
        )
        if (response) {
          this.totalRows = response.status === 200 ? response.data.Data : 0
        }
      }
    },
    async updateOptions (val) {
      this.currentOptions = val
      this.isUpdateEventTotal = false
      await this.getInstallationNotice(val)
    },
    async getNotInstallationNotice () {
      let response = await HttpInstallationNotice.GetNotWorkNotices()
      this.notWorkInstallationNoticeList = response.status === 200 ? response.data.Data : []
      this.notWorkInstallationNoticeList = this.notWorkInstallationNoticeList.filter(
        (x) => !x.IsCancel
      )
    },
    async getInstallationNotice (val) {
      if (this.isUpdateEventTotal) {
        this.currentOptions.page = 1
        this.countTotalRows()
      }
      this.isUpdateEventTotal = true
      this.isInstallationNoticeLoading = true
      if (this.installationNoticeSomeSource) {
        this.installationNoticeSomeSource.cancel('cancel')
      }
      let cancelToken = axios.CancelToken
      this.installationNoticeSomeSource = cancelToken.source()
      let param = {
        noticeNumber: this.filterInstallationNotice.NoticeNumber,
        customerId: this.filterInstallationNotice.CustomerId,
        licensePlate: this.filterInstallationNotice.LicensePlate,
        maintenanceEngineer: this.filterInstallationNotice.MaintenanceEngineer,
        quotationNumber: this.filterInstallationNotice.QuotationNumber,
        startQuotationNumber: this.filterInstallationNotice.StartQuotationNumber,
        endQuotationNumber: this.filterInstallationNotice.EndQuotationNumber,
        isRange: this.filterInstallationNotice.IsRange,
        firstContactName: this.filterInstallationNotice.FirstContactName,
        firstContactPhone: this.filterInstallationNotice.FirstContactPhone,
        secondContactName: this.filterInstallationNotice.SecondContactName,
        secondContactPhone: this.filterInstallationNotice.SecondContactPhone,
        carPlace: this.filterInstallationNotice.CarPlace,
        zoneType: this.filterInstallationNotice.ZoneType,
        specialNeedId: this.filterInstallationNotice.SpecialNeedId,
        itemsPerPage:
          typeof val === 'object' && val ? val.itemsPerPage : this.currentOptions.itemsPerPage,
        page: typeof val === 'object' && val ? val.page : this.currentOptions.page,
        sortBy: typeof val === 'object' && val ? val.sortBy[0] : this.currentOptions.sortBy,
        sortDesc: typeof val === 'object' && val ? val.sortDesc[0] : this.currentOptions.sortBy
      }
      let response = await HttpInstallationNotice.GetNotices(param)

      this.isInstallationNoticeLoading = false
      if (response) {
        this.installationNoticeList = response.status === 200 ? response.data.Data : []
        this.installationNoticeSomeSource = null
      }
    },
    convertToDateTimeFormat (timestamp) {
      if (timestamp === 0) {
        return '-'
      } else {
        return this.$moment(new Date(timestamp)).format('YYYY-MM-DD')
      }
    },
    async saveEditedInstallationNotice () {
      const isValid = await this.$refs.dialogEditedInstallationNotice.validate()
      if (isValid) {
        this.isLoadingSaveBtn = true
        this.isAllTextFieldDisable = true
        this.isInstallationNoticeLoading = true
        await HttpInstallationNotice.UpdateNotice(this.editedInstallationNotice)
        await this.getInstallationNotice()
        this.closeEditedInstallationNotice()
      }
    },
    async closeEditedInstallationNotice () {
      this.isShowEditInstallationNoticeDialog = false
      this.isInstallationNoticeLoading = false
      this.isLoadingSaveBtn = false
      this.isAllTextFieldDisable = false
      this.$nextTick(() => {
        let str = JSON.stringify(this.defaultInstallationNotice)
        this.editedInstallationNotice = JSON.parse(str)
        this.editedInstallationNoticeIndex = -1
      })
    },
    isShowEditInstallationNoticeDialogBtn (item) {
      this.editedInstallationNoticeIndex = this.installationNoticeList.indexOf(item)
      let str = JSON.stringify(item)
      this.editedInstallationNotice = JSON.parse(str)
      if (this.editedInstallationNotice.IsCancel || this.editedInstallationNotice.IsThrowToResume) {
        this.isAllTextFieldDisable = true
      }
      this.isShowEditInstallationNoticeDialog = true
    }
  }
}
</script>
